export const parseCurrency = (currency: string): string =>
  currency.trim().toLocaleLowerCase() === "gbp" ? "£" : currency;
